import { Injectable } from '@angular/core';
import { AdminBrandStatus } from '@web/shared/module/brand';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';

@Injectable({
  providedIn: 'root',
})
export class AdminBrandStatusProviderService {
  private readonly entries = new Map<AdminBrandStatus, string>([
    [AdminBrandStatus.Private, 'Prywatna'],
    [AdminBrandStatus.Public, 'Publiczna'],
    [AdminBrandStatus.Draft, 'Szkic'],
  ]);

  public labelFor(status: AdminBrandStatus): Observable<string> {
    const entry = this.entries.get(status);

    if (isNil(entry)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" code is not found.`,
      );
    }

    return of(entry);
  }

  public selectItems(): Observable<SelectItem<AdminBrandStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) => new SelectItem(label, status),
      ),
    );
  }
}
